import React from 'react';
import { Box, useTheme } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WorkIcon from '@mui/icons-material/Work';
import { useTranslation } from 'react-i18next';
import { StatCard } from './shared';
import { formatCurrency } from '../helpers';

const FirmStats = ({ contracts, offers, invoices, jobs, totalRevenue, showFinancial = true }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  // showFinancial=false durumunda gelir/fatura kartı dahil edilmez. Yetkisiz
  // kullanıcılar (INVOICE_MANAGEMENT view'i olmayanlar) bu kartı görmez.
  const stats = [
    {
      icon: <ArticleIcon sx={{ fontSize: 22 }} />,
      value: contracts.length,
      label: t('firmDetail.stats.contracts'),
      color: theme.palette.primary.main,
    },
    {
      icon: <LocalOfferIcon sx={{ fontSize: 22 }} />,
      value: offers.length,
      label: t('firmDetail.stats.offers'),
      color: '#f59e0b',
    },
    showFinancial && {
      icon: <TrendingUpIcon sx={{ fontSize: 22 }} />,
      value: invoices.length > 0 ? formatCurrency(totalRevenue) : '—',
      label: t('firmDetail.stats.revenue'),
      sublabel: invoices.length > 0
        ? `${invoices.length} fatura · ${t('firmDetail.avgRevenue')} ${formatCurrency(totalRevenue / invoices.length)}`
        : undefined,
      color: theme.palette.success.dark,
    },
    {
      icon: <WorkIcon sx={{ fontSize: 22 }} />,
      value: jobs.length,
      label: t('firmDetail.stats.jobs'),
      color: theme.palette.secondary.main,
    },
  ].filter(Boolean);

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
      {stats.map(stat => (
        <Box key={stat.label} sx={{ flex: 1, minWidth: 160 }}>
          <StatCard {...stat} />
        </Box>
      ))}
    </Box>
  );
};

export default FirmStats;
